import type { CSSObject } from '@mui/material/styles'
import type { Theme } from 'src/Theme'

import { ValidatedInput, CleanInput, WithError } from 'src/types/inputs'

const isValidInput = (input: ValidatedInput): input is CleanInput => input
  && typeof input === 'object'
  && (input.hasError === false || input.hasError === undefined)
  && !input.errorMessage

const isInvalidInput = (input: ValidatedInput): input is WithError => input
  && typeof input === 'object'
  && input.hasError === true
  && (typeof input.errorMessage === 'string' || input.errorMessage === undefined)

const inputValidationCustomProps = [
  'hasError',
  'errorMessage',
]

const inputVariantMixins = (theme: Theme): Record<string, CSSObject> => ({
  invalidField: {
    '&.MuiInputBase-root': {
      border: `${theme.sizes.borderWidth['1']} solid ${theme.colors.border.error}`,
      backgroundColor: theme.colors.surface['error-tertiary'],
    },
    '& .MuiInputBase-input': {
      backgroundColor: theme.colors.surface['error-tertiary'],
      '&::placeholder': {
        color: theme.colors.text.tertiary,
      },
      '&:active': {
        color: theme.colors.text.primary,
      },
      '&:enabled': {
        color: theme.colors.text.primary,
      },
    },
  },
  validField: {
    '&.MuiInputBase-root': {
      border: `${theme.sizes.borderWidth['1']} solid ${theme.colors.border.tertiary}`,
      background: theme.colors.surface.primary,
      '&:focus, &.Mui-focused': {
        border: `${theme.sizes.borderWidth['1']} solid ${theme.colors.border.focus}`,
      },
      '&:active': {
        border: `${theme.sizes.borderWidth['1']} solid ${theme.colors.border.focus}`,
      },
    },
    '& .MuiInputBase-input': {
      background: theme.colors.surface.primary,
      backgroundColor: theme.colors.surface.primary,
      '&::placeholder': {
        color: theme.colors.text.tertiary,
      },
      '&:active': {
        color: theme.colors.text.primary,
      },
      '&:enabled': {
        color: theme.colors.text.primary,
      },
    },
  },
  disabledField: {},
})

export {
  isValidInput,
  isInvalidInput,
  inputVariantMixins,
  inputValidationCustomProps,
}
